import styled from 'styled-components';
import colors from 'Styles/colors';
import { slideIn } from 'Styles/effects';

export const ModalContent = styled.div`
  padding: 24px 34px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  border-top: 10px solid ${colors.softBlue};
  background: ${({ theme }) => theme.backgrounds.modal};
  width: 505px;
  height: 829px;
  height: ${({ fullHeigth }) => fullHeigth ? '829px' : 'auto'};
  overflow: ${({ fullHeigth }) => fullHeigth ? 'auto' : 'visible'};;
  ${slideIn}
`;
ModalContent.displayName = 'ModalContent';

export const Content = styled.div`
display: flex;
flex-direction: column;
text-align: initial;
`;
